import React from "react";
import { pure } from "recompose";

import OnePanel from "./OnePanel";
import Text from "./Text";

const FinancingAnalysis = pure(() => (
  <OnePanel title="Financing Analysis">
    <Text>
      This section we are going to review Head of Finance decisions and how they
      impact your Income Statement.
    </Text>
  </OnePanel>
));

export default FinancingAnalysis;



// WEBPACK FOOTER //
// ./src/components/analysis/FinancingAnalysis.js